import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { getToolById } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NcFileVersions from '@components/ncFileVersions';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';

interface ToolsDetailsNCFileVersionsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ToolsDetailsNCFileVersionsComponent: FC<ToolsDetailsNCFileVersionsProps> = ({ getToolById, updateHeaderConfig, getNCFileById, ncFileData }) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NcFileVersions ncFile={ncFileData.data} loaded={ncFileData.wasLoaded} />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileVersions = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileVersionsComponent);

export { ToolsDetailsNCFileVersions };
